module.exports = __webpack_public_path__ + "static/media/post-img1.20e46384.jpg";